import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

// Standard Tailwind class-name merger. Variants conflict-resolved by twMerge.
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
